import React, { useCallback } from 'react'
import { Box, makeStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { PageTitle } from 'web/src/app/root/components/common'
import * as actions from '../actions'
import { BaitSettings } from '../../root/components/common/bait-settings'

const useStyles = makeStyles(theme => ({
    container: {
        maxWidth: 1200,
        padding: theme.spacing(3),
        overflowX: 'auto'
    },
    header: {
        fontSize: 32,
        fontWeight: 600,
        marginBottom: theme.spacing(4),
        color: theme.textPrimary
    },
    serialNumber: {
        color: theme.textSecondary,
        flex: 1,
        fontStyle: 'italic'
    },
    pageTitle: {
        alignItems: 'baseline'
    },
    settingRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(3, 0),
        borderBottom: `1px solid ${theme.grayLight}`,
        '&:last-child': {
            borderBottom: 'none'
        }
    },
    settingLeft: {
        flex: 1,
        paddingRight: theme.spacing(4)
    },
    settingRight: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        flexWrap: 'wrap'
    },
    settingTitle: {
        fontSize: 16,
        fontWeight: 600,
        marginBottom: theme.spacing(0.5),
        color: theme.textPrimary
    },
    settingDescription: {
        fontSize: 14,
        color: theme.textSecondary
    },
    select: {
        minWidth: 120,
        '& .MuiOutlinedInput-root': {
            borderRadius: theme.borderRadius
        }
    },
    input: {
        width: 90,
        '& .MuiOutlinedInput-root': {
            borderRadius: theme.borderRadius
        }
    },
    baitTypeInput: {
        width: 200
    },
    baitAmountInput: {
        width: 100
    },
    saveButton: {
        minWidth: 100
    },
    thresholdChip: {
        marginTop: theme.spacing(1)
    },
    replaceBaitButton: {
        color: theme.error,
        borderColor: theme.error,
        '&:hover': {
            backgroundColor: `${theme.error}10`,
            borderColor: theme.error
        }
    },
    lastReplacementText: {
        fontSize: 14,
        color: theme.textSecondary,
        fontStyle: 'italic',
        marginRight: theme.spacing(2)
    }
}))

export const DeviceSettings = ({
    device,
    reloadDevice,
    canUpdate,
    overridingLocationSettings
}) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const { locale } = useSelector(state => state.main)

    const updateDeviceFromBaitSettings = useCallback(
        data => {
            dispatch(actions.updateDeviceRequest(device.id, data))
        },
        [device.id]
    )

    return (
        <Box className={classes.container}>
            <PageTitle
                title={locale.common.settings}
                position="center"
                className={classes.pageTitle}
            >
                <span className={classes.serialNumber}>
                    ({device?.serial_number})
                </span>
            </PageTitle>

            <BaitSettings
                data={device}
                reloadDevice={reloadDevice}
                canUpdate={canUpdate}
                isDevice={true}
                isLocationSettings={false}
                updateData={updateDeviceFromBaitSettings}
                overridingLocationSettings={overridingLocationSettings}
            />
        </Box>
    )
}
